export const ContactFormId = 'contact-us'
export const CTATargetId = 'cta-target'

export const PageColorDataAttribute = 'data-page-color'
export const PageColorDataProps = { [PageColorDataAttribute]: true }
